export function parseAnswers(formInstanceId, questions, values) {
    const questionIds = questions.map(q => q.id);

    const changedFields = values ? Object.keys(values) : [];
    const answerQids = changedFields.filter(fieldName => questionIds.includes(fieldName));
    const answers = answerQids.map(answerQid => {
        const question = questions.find(q => q.id === answerQid);
        const { value, ...attributes } = values[answerQid];
        const response = {
            question_id: answerQid,
            answer: value,
            attributes,
            form_instance_id: formInstanceId,
            id: question && question.answer && question.answer.id
        };
        return response;
    });

    return answers;
}

export function answersToInitialValues(answers) {
    let values = {};
    answers.forEach(answerObject => {
        const { answer, question_id } = answerObject;
        values[question_id] = { value: answer };
    });

    return values;
}

export function answersToInitialValuesWithAttributes(answers) {
    let values = {};
    answers.forEach(answerObject => {
        const { answer, question_id, attributes } = answerObject;
        values[question_id] = { value: answer };
        Object.entries(attributes || {}).forEach(([attributeQuestion, attributeValues]) => {
            values[question_id][attributeQuestion] = attributeValues;
        });
    });

    return values;
}
export function answersToSimpleInitialValues(answers) {
    let values = {};
    answers.forEach(answerObject => {
        const { answer, question_id } = answerObject;
        values[question_id] = answer;
    });

    return values;
}

export function objectToFormInstanceValues(answerObject) {
    const fields = answerObject ? Object.keys(answerObject) : [];
    let values = {};
    fields.forEach(field => {
        values[field] = { value: answerObject[field] };
    });

    return values;
}



// WEBPACK FOOTER //
// ./src/utilities/formInstances.jsx